(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collapsible-text"] && !Shopify.designMode) return;
  try {
    class CollapsibleTextComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.content = this.querySelector('.collapsible-text-content');
      this.button = this.querySelector('.collapsible-text-button-wrapper');
      this.buttonText = this.button.querySelector('button');
      
      if (!this.button || !this.content) return;

      this.showText = this.buttonText.getAttribute('data-show-text');
      this.hideText = this.buttonText.getAttribute('data-hide-text');
      this.isExpanded = false;

      this.checkIfButtonNeeded();
      this.setupEventListeners();
    }

    checkIfButtonNeeded() {
      const contentHeight = this.content.scrollHeight;
      const previewHeight = this.content.getAttribute('data-content-height');
      
      if (contentHeight <= previewHeight) {
        this.button.style.display = 'none';
        this.content.classList.remove('collapsed');
      }
    }

    setupEventListeners() {
      this.button.addEventListener('click', () => {
        this.toggleContent();
      });
    }

    toggleContent() {
      this.isExpanded = !this.isExpanded;
      
      if (this.isExpanded) {
        this.content.classList.remove('collapsed');
        this.content.classList.add('expanded');
        this.buttonText.textContent = this.hideText;
        this.button.setAttribute('aria-expanded', 'true');
      } else {
        this.content.classList.remove('expanded');
        this.content.classList.add('collapsed');
        this.buttonText.textContent = this.showText;
        this.button.setAttribute('aria-expanded', 'false');
      }
    }
  }
  if (!customElements.get('collapsible-text-component')) customElements.define('collapsible-text-component', CollapsibleTextComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compre-junto-inferior"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';

  // Utilitários
  const debounce = (fn, ms) => {
    let t;
    return function(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), ms);
    };
  };

  const formatCurrency = (value) => value.toLocaleString('pt-BR', { 
    style: 'currency', 
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  document.addEventListener('DOMContentLoaded', function () {
    const compreJuntoSection = document.querySelector('.compre-junto-inferior-section');
    if (!compreJuntoSection) return;

    // Abrir carrinho após reload
    if (sessionStorage.getItem('openCartDrawer') === 'true') {
      sessionStorage.removeItem('openCartDrawer');
      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer?.open) {
          cartDrawer.open();
        } else {
          document.querySelector('.header__icon--cart, #cart-icon-bubble')?.click();
        }
      }, 800);
    }

    const mainProductElement = document.querySelector('.main-product-inferior');
    const items = document.querySelectorAll('.compre-junto-inferior-item');
    const totalPriceElement = document.getElementById('total-price-inferior');
    const totalComparePriceElement = document.getElementById('total-compare-price-inferior');
    const addButton = document.querySelector('.compre-junto-inferior-btn');

    // Atualizar total
    function updateTotal() {
      let total = 0;
      let totalCompare = 0;
      let selectedItems = [];
      
      items.forEach(item => {
        if (item.getAttribute('data-selected') === 'true') {
          total += parseFloat(item.getAttribute('data-price'));
          totalCompare += parseFloat(item.getAttribute('data-compare-price') || item.getAttribute('data-price'));
          selectedItems.push(item.getAttribute('data-id'));
        }
      });
      
      if (totalComparePriceElement) {
        totalComparePriceElement.parentElement.style.display = totalCompare <= total ? 'none' : 'block';
        totalComparePriceElement.textContent = formatCurrency(totalCompare);
      }
      
      totalPriceElement.textContent = formatCurrency(total);
      addButton.disabled = selectedItems.length < 1;
    }

    const debouncedUpdate = debounce(updateTotal, 80);

    // Sincronizar preços
    function syncPriceWithVisibleCard(item) {
      const select = item.querySelector('.compre-junto-inferior-select-variant');
      const ddLast = item.querySelector('.price__last[data-last]');
      const ddCompare = item.querySelector('.price__compare[data-compare]');

      let currentFromOption = null;
      let compareFromOption = null;

      if (select?.options.length) {
        const opt = select.options[select.selectedIndex];
        currentFromOption = parseFloat(opt.getAttribute('data-current-price'));
        compareFromOption = parseFloat(opt.getAttribute('data-compare-price'));
      }

      if (ddLast) {
        const domPrice = parseInt(ddLast.dataset.last, 10) / 100;
        item.setAttribute('data-price', Number.isFinite(domPrice) ? domPrice : currentFromOption);
      } else if (Number.isFinite(currentFromOption)) {
        item.setAttribute('data-price', currentFromOption);
      }

      if (ddCompare) {
        const domCompare = parseInt(ddCompare.dataset.compare, 10) / 100;
        item.setAttribute('data-compare-price', Number.isFinite(domCompare) ? domCompare : compareFromOption);
      } else if (Number.isFinite(compareFromOption)) {
        item.setAttribute('data-compare-price', compareFromOption);
      }
    }

    // Inicializar checkboxes
    function initCheckboxes() {
      items.forEach(item => {
        const isSelected = item.getAttribute('data-selected') === 'true';
        const checkboxCircle = item.querySelector('.compre-junto-inferior-checkbox-circle');
        checkboxCircle?.classList.toggle('checked', isSelected);
      });
    }

    // Configurar itens
    items.forEach(item => {
      if (item.classList.contains('main-product-inferior')) {
        item.setAttribute('data-selected', 'true');
        item.querySelector('.compre-junto-inferior-checkbox-circle')?.classList.add('checked');
        return;
      }

      const selectionBox = item.querySelector('.compre-junto-inferior-selection-box');
      const checkboxCircle = item.querySelector('.compre-junto-inferior-checkbox-circle');
      const isUnavailable = selectionBox?.getAttribute('data-disabled') === 'true';

      if (isUnavailable) {
        item.setAttribute('data-selected', 'false');
        checkboxCircle?.classList.remove('checked');
        item.classList.add('compre-junto-inferior-item-unavailable');
      } else {
        selectionBox?.addEventListener('click', (e) => {
          e.stopPropagation();
          const isSelected = item.getAttribute('data-selected') === 'true';
          item.setAttribute('data-selected', !isSelected ? 'true' : 'false');
          checkboxCircle?.classList.toggle('checked', !isSelected);
          updateTotal();
        });
      }
    });

    // Configurar selects de variantes
    document.querySelectorAll('.compre-junto-inferior-select-variant').forEach(selectElement => {
      const parentItem = selectElement.closest('.compre-junto-inferior-item');
      if (!parentItem) return;

      if (!parentItem.classList.contains('main-product-inferior')) {
        const initialOption = selectElement.options[selectElement.selectedIndex];
        parentItem.setAttribute('data-id', initialOption.value);
        parentItem.setAttribute('data-price', parseFloat(initialOption.getAttribute('data-current-price')));
        
        const imgElement = parentItem.querySelector('.compre-junto-inferior-item-image-display');
        if (imgElement) imgElement.src = initialOption.getAttribute('data-image');
      }

      selectElement.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const newVariantId = parseInt(selectedOption.value);
        const newImage = selectedOption.getAttribute('data-image');

        parentItem.setAttribute('data-id', newVariantId);
        parentItem.setAttribute('data-price', parseFloat(selectedOption.getAttribute('data-current-price')));
        parentItem.setAttribute('data-compare-price', parseFloat(selectedOption.getAttribute('data-compare-price')));

        const imgElement = parentItem.querySelector('.compre-junto-inferior-item-image-display');
        if (imgElement) imgElement.src = newImage;
        
        syncPriceWithVisibleCard(parentItem);
        debouncedUpdate();
      });
    });

    // Botão adicionar ao carrinho
    addButton.addEventListener('click', function() {
      addButton.disabled = true;
      const originalText = addButton.textContent;
      addButton.textContent = 'Adicionando...';

      const itemsToAdd = Array.from(items)
        .filter(item => item.getAttribute('data-selected') === 'true')
        .map(item => ({ id: parseInt(item.getAttribute('data-id')), quantity: 1 }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(error => { throw new Error(error.description || 'Erro desconhecido'); });
        }
        sessionStorage.setItem('openCartDrawer', 'true');
        window.location.reload();
      })
      .catch(error => {
        console.error('Erro ao adicionar itens:', error);
        addButton.textContent = 'Erro!';
        addButton.style.backgroundColor = '#f44336';
        setTimeout(() => {
          addButton.textContent = originalText;
          addButton.style.backgroundColor = '';
          updateTotal();
        }, 2500);
      });
    });

    // Hover de imagens
    items.forEach(item => {
      if (item.dataset.listenersBound === '1') return;
      item.dataset.listenersBound = '1';

      const img = item.querySelector('.compre-junto-inferior-item-image-display');
      const imgBox = item.querySelector('.compre-junto-inferior-item-image');
      const select = item.querySelector('.compre-junto-inferior-select-variant');

      function getUrls() {
        if (select?.options.length) {
          const opt = select.options[select.selectedIndex];
          return {
            main: opt.getAttribute('data-image') || '',
            second: opt.getAttribute('data-image-second') || ''
          };
        }
        return {
          main: item.getAttribute('data-image') || '',
          second: item.getAttribute('data-image-second') || ''
        };
      }

      if (imgBox && !imgBox.dataset.hoverBound) {
        imgBox.dataset.hoverBound = '1';
        imgBox.addEventListener('mouseenter', () => {
          if (!img) return;
          const urls = getUrls();
          if (urls.second) {
            img.dataset._swapBackup = img.src;
            img.src = urls.second;
          }
        }, { passive: true });

        imgBox.addEventListener('mouseleave', () => {
          if (!img) return;
          if (img.dataset._swapBackup) {
            img.src = img.dataset._swapBackup;
            delete img.dataset._swapBackup;
          }
        }, { passive: true });
      }

      syncPriceWithVisibleCard(item);
    });

    // Sincronização com variante principal
    function syncMainVariant() {
      const list = (() => {
        const el = document.querySelector('.main-product-inferior .cj-main-variants');
        if (!el) return [];
        try { return JSON.parse(el.textContent || '[]'); } catch { return []; }
      })();

      const id = (() => {
        const input = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
        if (!input) return null;
        const val = parseInt(input.value, 10);
        return isNaN(val) ? null : val;
      })();

      if (!id || !list.length) return;

      const variant = list.find(v => v?.id === id);
      if (!variant) return;

      const wrap = document.querySelector('.main-product-inferior');
      if (!wrap) return;

      wrap.setAttribute('data-id', variant.id);
      const hid = wrap.querySelector('.cj-variant-id');
      if (hid) hid.value = variant.id;

      const sel = wrap.querySelector('#main-select-combined');
      if (sel) {
        const opt = Array.from(sel.options).find(o => parseInt(o.value, 10) === variant.id);
        if (opt) sel.value = opt.value;
      }

      const img = wrap.querySelector('.compre-junto-inferior-item-image-display');
      if (img && sel?.selectedOptions?.[0]) {
        const url = sel.selectedOptions[0].dataset.image;
        if (url) img.src = url;
      }
    }

    document.addEventListener('variant:change', syncMainVariant, true);
    const idInput = document.querySelector('input[name="id"]');
    if (idInput) idInput.addEventListener('change', syncMainVariant);

    // Cálculo de badges
    function setBadgeLabel(badge, newText) {
      const slots = ['.sale-badge__text', '.label_sale', '.label_sale_percent', '.badge__text', '[data-badge-text]'];
      for (const sel of slots) {
        const el = badge.querySelector(sel);
        if (el) { el.textContent = newText; return; }
      }
      const tn = Array.from(badge.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.nodeValue.trim().length);
      if (tn) { tn.nodeValue = ' ' + newText + ' '; return; }
      const span = document.createElement('span');
      span.className = 'sale-badge__text';
      span.textContent = newText;
      badge.appendChild(span);
    }

    function processItem(item) {
      const compareDD = item.querySelector('.price__compare[data-compare]');
      const lastDD = item.querySelector('.price__last[data-last]');
      const badge = item.querySelector('.sale-badge, .price__badge-sale, .badge[class*="sale"]');
      
      if (!compareDD || !lastDD || !badge) return;

      const compare = parseInt(compareDD.dataset.compare, 10);
      const price = parseInt(lastDD.dataset.last, 10);
      
      if (!Number.isFinite(compare) || !Number.isFinite(price) || compare <= 0) return;

      const priceSemPix = Math.round((price * 100) / 100);
      const savings = Math.max(0, compare - priceSemPix);
      const pct = Math.round((savings * 100) / compare);

      if (pct >= 1) setBadgeLabel(badge, `-${pct}% OFF`);
    }

    function aplicarCalculoBadges() {
      items.forEach(processItem);
    }

    const observer = new MutationObserver(aplicarCalculoBadges);
    observer.observe(compreJuntoSection, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-compare', 'data-last']
    });

    // Inicialização
    window.addEventListener('pageshow', () => {
      items.forEach(syncPriceWithVisibleCard);
      initCheckboxes();
    });

    items.forEach(syncPriceWithVisibleCard);
    initCheckboxes();
    updateTotal();
    syncMainVariant();
    aplicarCalculoBadges();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy')
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
